<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Gestion des statuts</h2>
    <p class="page-subtitle">Configurez les statuts personnalisés pour vos projets</p>
  </div>
  <button (click)="openCreateDialog()" class="btn btn-primary btn-with-icon">
    <mat-icon aria-hidden="true">add</mat-icon>
    Nouveau statut
  </button>
</div>

@if (errorMessage) {
<div class="alert alert-error mb-4">
  {{ errorMessage }}
  <button class="close-alert" (click)="errorMessage = ''">×</button>
</div>
}
@if (successMessage) {
<div class="alert alert-success mb-4">
  {{ successMessage }}
  <button class="close-alert" (click)="successMessage = ''">×</button>
</div>
}

<div class="card shadow-sm mb-4">
  <div class="search-bar">
    <div class="search-bar-content">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Rechercher un statut..."
          class="search-input"
        >
      </div>
      <div class="filters-row">
        <select class="filter-select" [ngModel]="typeFilter" (ngModelChange)="onTypeFilterChange($event)">
          @for (type of statusTypeOptions; track type) {
            <option [value]="type">{{ type === 'ALL' ? 'Tout' : type }}</option>
          }
        </select>
        <select class="filter-select" [ngModel]="metaStatusFilter" (ngModelChange)="onMetaStatusFilterChange($event)">
          <option value="ALL">Tous les méta-statuts</option>
          @for (meta of metaStatusOptions; track meta) {
            <option [value]="meta">{{ meta }}</option>
          }
        </select>
        <div class="archived-toggle">
          <label class="checkbox-container">
            <input type="checkbox" [checked]="showArchived" (change)="onToggleArchived()">
            <span class="checkmark"></span>
            Afficher les archivés
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="modern-table">
      <thead>
        <tr>
          <th>Nom du statut</th>
          <th>Type</th>
          <th>Méta-statut</th>
        </tr>
      </thead>
      <tbody>
        @for (status of statuses; track status.id) {
        <tr class="clickable-row" (click)="openEditDialog(status)">
          <td class="font-bold">
            <div class="name-with-color">
              <span class="color-indicator" [style.background-color]="status.color"></span>
              {{ status.name }}
            </div>
          </td>
          <td>{{ status.type || 'PROJECT' }}</td>
          <td>
            <span class="status-badge" [attr.data-meta]="status.metaStatus">
              {{ status.metaStatus }}
            </span>
          </td>
        </tr>
        } @empty {
        <tr class="empty-row">
          <td colspan="3">
            <div class="empty-state">
              <mat-icon class="empty-icon" aria-hidden="true">settings</mat-icon>
              <p>Aucun statut configuré</p>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  <mat-paginator [length]="totalElements()"
                 [pageSize]="size()"
                 [pageSizeOptions]="[5, 10, 25, 100]"
                 (page)="onPageChange($event)"
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>
